import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import FormGroup from '../helpers/FormGroup'

class CompanySocial extends React.Component {
  constructor(props) {
    super(props)
  }

  validate() {
    //
  }

  render() {
    const values = this.props.data
    const setData = this.props.setData

    return(
      <fieldset className="fieldset">
        <legend className="h2">Company Details</legend>
        <div className="row">
          <div className="col-12">
            <FormGroup label="Website URL" value={values.url} onChange={(v) => setData({url: v})} />
          </div>
          <div className="col-12">
            <FormGroup label="LinkedIn" value={values.linked_in} onChange={(v) => setData({linked_in: v})} />
          </div>
          <div className="col-12">
            <FormGroup label="Twitter" value={values.twitter} onChange={(v) => setData({twitter: v})} />
          </div>
          <div className="col-12">
            <FormGroup label="Facebook" value={values.facebook} onChange={(v) => setData({facebook: v})} />
          </div>
          <div className="col-12">
            <FormGroup label="Instagram" value={values.instagram} onChange={(v) => setData({instagram: v})} />
          </div>
        </div>
      </fieldset>
    )
  }
}

export default CompanySocial